module.exports = __webpack_public_path__ + "static/media/Planetita2.0e8d92f3.png";